import React from 'react';
import { Icon } from '@iconify/react';
import { cn } from '../lib/utils';
import { useMyList } from '../lib/my-list-context';

export function MyListButton({
  title,
  size = 'default',
  variant = 'icon',
  className,
}) {
  const { isInList, toggleList } = useMyList();
  const [animating, setAnimating] = React.useState(false);

  if (!title) return null;
  const id = title.id || title.Id || title.MovieId;
  if (!id) return null;

  const inList = isInList(id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnimating(true);
    toggleList(title);
    setTimeout(() => setAnimating(false), 300);
  };

  const sizeClasses = {
    sm: 'size-8 text-xs',
    default: 'size-10 text-sm',
    lg: 'size-12 text-base',
  }[size] || 'size-10 text-sm';

  const iconSizes = {
    sm: 'size-3.5',
    default: 'size-4.5',
    lg: 'size-5',
  }[size] || 'size-4.5';

  if (variant === 'pill') {
    return (
      <button
        type="button"
        onClick={handleClick}
        aria-label={
          inList
            ? `Remove ${title.title || title.Title} from my list`
            : `Add ${title.title || title.Title} to my list`
        }
        className={cn(
          'inline-flex h-10 items-center gap-2 rounded-full px-4 text-sm font-medium transition-all duration-200 backdrop-blur-md select-none',
          inList
            ? 'border border-emerald-500/40 bg-emerald-500/15 text-emerald-300 hover:border-emerald-500/60 hover:bg-emerald-500/25'
            : 'border border-white/20 bg-white/10 text-white hover:border-white/35 hover:bg-white/15',
          animating && 'scale-95',
          className
        )}
      >
        <Icon
          icon={inList ? 'ph:check-bold' : 'ph:plus-bold'}
          className={cn('size-4 transition-transform duration-200', animating && 'rotate-12')}
        />
        <span>{inList ? 'In My List' : 'Add to List'}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={
        inList
          ? `Remove ${title.title || title.Title} from my list`
          : `Add ${title.title || title.Title} to my list`
      }
      title={inList ? 'Remove from My List' : 'Add to My List'}
      className={cn(
        'relative flex items-center justify-center rounded-full transition-all duration-200 backdrop-blur-md select-none cursor-pointer',
        sizeClasses,
        inList
          ? 'border border-emerald-500/40 bg-emerald-500/15 text-emerald-400 hover:border-emerald-500/60 hover:bg-emerald-500/25 hover:text-emerald-300 shadow-[0_0_12px_rgba(16,185,129,0.2)]'
          : 'border border-white/25 bg-white/10 text-white hover:border-white/40 hover:bg-white/20 hover:text-white',
        animating && 'scale-90',
        className
      )}
    >
      <Icon
        icon={inList ? 'ph:check-bold' : 'ph:plus-bold'}
        className={cn(
          iconSizes,
          'transition-transform duration-200',
          animating && 'scale-125'
        )}
      />
    </button>
  );
}

export default MyListButton;
